var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnComments = function SvgIcnComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.806 5H7.083A2.083 2.083 0 0 0 5 7.083v6.945a2.083 2.083 0 0 0 2.083 2.083h8.049l2.57 2.576a.693.693 0 0 0 .756.146.694.694 0 0 0 .43-.639V7.084A2.083 2.083 0 0 0 16.807 5Zm.694 11.52-1.59-1.596a.693.693 0 0 0-.493-.202H7.083a.694.694 0 0 1-.694-.694V7.083a.694.694 0 0 1 .694-.694h9.723a.694.694 0 0 1 .694.694v9.438Z",
    fill: "#292525"
  })));
};
export default SvgIcnComments;